import React, { Component } from 'react';
import { Dropdown, Grid, Button, TextArea, Form, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import history from '../../history';
import { setDraftStake, setEditStake } from '../rootReducer';

import './CreateStake.css';
import 'rc-slider/assets/index.css';

import OddsSlider from './OddsSlider.js';
import StakeSlider from './StakeSlider.js';

import { STATUS } from '../../utils/status';

class CreateStake extends Component {
  constructor(props) {
    super(props);

    const users = props.users.map(x => ({
      key: x.email,
      value: x.user_id,
      text: x.name,
      image: { avatar: true, src: x.picture }
    }));

    this.state = {
      users: users,
      form: props.editStake ||
        props.draftStake || {
          title: '',
          rules: '',
          odds: 2,
          amount: Math.floor(this.props.balance / 10),
          currency: 'STAKE',
          status: STATUS.Draft
        },
      errors: {
        stakee: null
      }
    };
  }

  setFormState = (field, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [field]: value
      }
    });

    if (this.state.errors.stakee && field === 'stakee') {
      this.setState({ errors: { ...this.state.errors, stakee: null } });
    }
  };

  handleChange = (e, { name, value }) => this.setFormState(name, value);

  handleOddsChange = value => this.setFormState('odds', value);

  handleStakeChange = value => this.setFormState('amount', value);

  handleSubmit = () => {
    const { form: newStake } = this.state;

    if (!newStake.stakee) {
      this.setState({
        errors: {
          ...this.state.errors,
          stakee: true
        }
      });
      return;
    }

    newStake.title = newStake.title.trim();
    if (this.props.editStake) {
      newStake.editedFields = [];
      if (newStake.title !== this.props.editStake.title)
        newStake.editedFields.push('title');
        
      if (newStake.rules !== this.props.editStake.rules)
        newStake.editedFields.push('rules');

      if (newStake.amount !== this.props.editStake.amount)
        newStake.editedFields.push('amount');
      
      if (newStake.odds !== this.props.editStake.odds)
        newStake.editedFields.push('odds');

      this.props.setEditStake(newStake, this.props.editStake);
      history.push('/confirmEdit');
    }

    // Get full stakee user object
    const stakee = this.props.users.find(x => x.user_id === newStake.stakee);
    if (!stakee) return;
    newStake.stakeeProfile = { name: stakee.nickname, avatar: stakee.picture };
    
    this.props.setDraftStake(newStake);
    history.push('/confirm-draft');
  };

  render() {
    const form = this.state.form;
    return (
      <Form id="create-stake" onSubmit={this.handleSubmit}>
        <Form.Field>
          <label className="title">Name</label>
          <div className="sub-label">Name your stake</div>
          <Input
            placeholder="e.g. arm wrestle"
            name="title"
            value={form.title}
            onChange={this.handleChange}
            required
          />
        </Form.Field>

        {!this.props.editStake && (
          <Form.Field>
            <label className="title">Pick your stakee</label>
            <div className="sub-label">Who do you wish to challenge?</div>
            {/* <Input icon="search" placeholder="Search..." /> */}
            <Dropdown
              name="stakee"
              placeholder="Select Friend"
              fluid
              selection
              search
              value={form.stakee}
              options={this.state.users}
              onChange={this.handleChange}
              onFocus={ev => ev.target.closest('.field').scrollIntoView(true)}
              error={this.state.errors.stakee}
            />
          </Form.Field>
        )}

        <Form.Field>
          <label className="title">Rules</label>
          <div className="sub-label">Describe the rules and conditions of your stake</div>
          <TextArea
            value={form.rules}
            autoHeight
            placeholder="- Standard American arm wrestling rules"
            name="rules"
            rows={3}
            onChange={this.handleChange}
          />
        </Form.Field>

        {/* <Form.Field>
          <label className="title">Outcome criteria</label>
          <div className="sub-label">Define your win and lose criteria</div>
          <TextArea autoHeight placeholder="Win" name="win-citeria" rows={1} onChange={this.handleChange} />
        </Form.Field>
        <Form.Field>
          <TextArea autoHeight placeholder="Lose" name="lose-citeria" rows={1} onChange={this.handleChange} />
        </Form.Field> */}

        <Form.Field>
          <StakeSlider balance={this.props.balance} stake={form.amount} handleStakeChange={this.handleStakeChange} />
        </Form.Field>

        <Form.Field>
          <OddsSlider stakeAmount={form.amount} odds={form.odds} handleOddsChange={this.handleOddsChange} />
        </Form.Field>

        <Form.Field>
          <label className="title">Adjudication</label>
          <div className="sub-label">How will the bet be settled?</div>

          <Grid>
            <Grid.Column width={6}>
              <Button as="div" fluid basic color="blue">
                Simple
              </Button>
              <Button as="div" fluid basic disabled>
                Nominate
              </Button>
              <Button as="div" fluid basic disabled>
                Staker Panel
              </Button>
            </Grid.Column>
            <Grid.Column width={10}>
              <div className="adjudication-text">Completion requires mutual agreement</div>
              <div className="adjudication-text disabled">Nominate a mutual friend to act as adjudicator</div>
              <div className="adjudication-text disabled">Panel of for profit adjudicators consensus.</div>
            </Grid.Column>
          </Grid>
        </Form.Field>

        <Form.Field>
          {/* <Input icon="search" placeholder="Search" /> */}
          {/* <Dropdown placeholder="Select Friend" fluid selection search options={friends} /> */}
        </Form.Field>

        <Form.Button type="submit" fluid primary size="large">
          {this.props.editStake ? 'Edit Stake' : 'Stake it'}
        </Form.Button>
      </Form>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  draftStake: app.draftStake,
  users: app.users,
  balance: app.availableBalance
});

export default connect(mapStateToProps, { setDraftStake, setEditStake })(CreateStake);



// WEBPACK FOOTER //
// ./src/App/CreateStake/CreateStake.js